<template>
    <v-data-table v-bind="{ items, headers }" mobile-breakpoint="10000" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined nshop-order-view-section">
        <template #top> <div class="table-label px-1 white">주문정보</div> </template>
        <template v-for="(header, index) in headers.filter((h) => h.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { initDataTableHeaders } from "@/assets/lib";
import { NSHOP_ORDER_STATES } from "@/store/nshop";

export default {
    props: {
        order: { type: Object, default: () => ({}) },
    },
    computed: {
        items() {
            return [this.order];
        },
        headers() {
            const headers = [
                { text: "주문번호", value: "orderNo" },
                { text: "권종", value: "orderName" },
                { text: "수량", value: "count" },
                { text: "주문상태", value: "state", formatter: (v) => NSHOP_ORDER_STATES[v]?.text || "-" },
                { text: "생성일시", value: "createdAt", formatterType: "datetime" },
                { text: "결제일시", value: "paymentAt", formatterType: "datetime" },
            ];
            if (this.order?.stoppedAt) headers.push({ text: "주문취소일시", value: "stoppedAt", formatterType: "datetime" });
            if (this.order?.canceledAt) headers.push({ text: "결제취소일시", value: "canceledAt", formatterType: "datetime" });
            return initDataTableHeaders(headers);
        },
    },
};
</script>
